import { render, staticRenderFns } from "./addRecords.vue?vue&type=template&id=ca3a3470&scoped=true"
import script from "./addRecords.vue?vue&type=script&lang=js"
export * from "./addRecords.vue?vue&type=script&lang=js"
import style0 from "./addRecords.vue?vue&type=style&index=0&id=ca3a3470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3a3470",
  null
  
)

export default component.exports